<template>
  <div>
    <AppLayout title="Produtos">
      <template #actions>
        <select v-if="lista_lojas.length > 1" v-model="selectedStoreId" @change="refresh(1)" class="form-select form-select-sm w-auto">
          <option v-for="loja in lista_lojas" :key="loja.id" :value="loja.id">{{ loja.name }}</option>
        </select>
        <button type="button" class="btn btn-primary" @click="show_novoProduto">Novo Produto</button>
      </template>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th><i class="bi bi-upc"></i> Código de Barras</th>
              <th>Estoque</th>
              <th>Medida</th>
              <th>Compra</th>
              <th>Venda</th>
              <th>Visivel?</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="produto in lista_produtos" :key="produto.id">
              <td>{{ produto.name }}</td>
              <td>{{ produto.code }}</td>
              <td>{{ produto.stock }}</td>
              <td>{{ produto.measure }}</td>
              <td>R$ {{ produto.buy.toFixed(2) }}</td>
              <td>R$ {{ produto.price.toFixed(2) }}</td>
              <td><i v-if="produto.visible" class="bi bi-eye-fill"></i><i v-else class="bi bi-eye-slash"></i></td>
              <td style="width:50px"><button @click="show_repor(produto)" type="button" class="btn btn-success btn-sm"><i class="bi bi-plus-circle-fill"></i></button></td>
              <td style="width:50px"><button @click="show_descart(produto)" type="button" class="btn btn-warning btn-sm"><i class="bi bi-file-earmark-x-fill"></i></button></td>
              <td style="width:50px"><button @click="show_editProduct(produto)" type="button" class="btn btn-primary btn-sm"><i class="bi bi-pencil-square"></i></button></td>
              <td style="width:50px" v-if="false"><button type="button" class="btn btn-info btn-sm"><i class="bi bi-hourglass-split"></i></button></td>
              <td style="width:50px" v-if="false"><button :disabled="autorizated_delet == 0" @click="show_deleteProduct(produto)" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginação -->
      <nav aria-label="Paginação de produtos" class="mt-3">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
              <i class="bi bi-chevron-left"></i> Anterior
            </button>
          </li>
          <li class="page-item" v-for="p in pages" :key="p" :class="{ active: p === currentPage }">
            <button class="page-link" @click="changePage(p)">{{ p }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
              Próximo <i class="bi bi-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </AppLayout>

    <!-- Modal Produto -->
    <div class="modal fade" id="modal_produto" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
        <div class="modal-header">
          <div v-if="edit" >
            <h5 class="modal-title">Editar Produto</h5>
          </div>
          <div v-else >
            <h5  class="modal-title">Novo Produto</h5>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form id="form-produto" @submit.prevent="preActionProduct">
          <div class="modal-body">
              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label">Nome:</label>
                <input value="" v-model="produto.name" type="text" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com">
              </div>
              <div class="row">
                <div class="mb-3 col">
                  <label for="exampleFormControlInput1" class="form-label">Codigo de Barras:</label>
                  <input value="" :readonly="edit == false" v-model="produto.code" type="text" class="form-control" id="exampleFormControlInput1">
                </div>
                <div class="mb-3 col">
                  <label for="exampleFormControlInput1" class="form-label">Preço de Venda:</label>
                  <input value="" v-model="produto.price" type="number" step="0.01" class="form-control" id="exampleFormControlInput1">
                </div>
              </div>
              <div class="row">
                <div class="mb-3 col">
                  <label for="exampleFormControlInput1" class="form-label">Medida:</label>
                  <select v-model="produto.measure" class="form-select" aria-label="Default select example">
                    <option selected>Selecione</option>
                    <option value="UN">Unidade</option>
                    <option value="KG">Kg</option>
                    <option value="LT">Litros</option>
                  </select>
                </div>
                <div class="mb-3 col">
                  <div class="form-check">
                    <input :value=1 class="form-check-input" type="radio" v-model="produto.visible" name="visible" id="visible">
                    <label class="form-check-label" for="visible">Visivel</label>
                  </div>
                  <div class="form-check">
                    <input :value=0 class="form-check-input" type="radio" v-model="produto.visible" name="visible" id="invisible">
                    <label class="form-check-label" for="invisible">Invisivel</label>
                  </div>
                </div>
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="button" @click="actionProduct" class="btn btn-primary">Salvar</button>
          </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Modal deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Deletar Produto?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ produto.name }}</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="deleteProduct" class="btn btn-danger">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">{{ feedback_error ? 'Não foi possível concluir' : 'Sucesso' }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ msn_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Movimentação -->
    <div class="modal fade" id="modal_movimentacao" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
        <div class="modal-header">
          <div v-if="descart" >
            <h5 class="modal-title">Descartar Estoque</h5>
          </div>
          <div v-else >
            <h5  class="modal-title">Repor Produtos</h5>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form id="form-produto" @submit.prevent="actionMoviment">
          <div class="modal-body">
            <h4>{{ produto.name }}</h4>
            <div class="row">
              <div class="col mb-3">
                <label for="exampleFormControlInput1" class="form-label">Quantidade:</label>
                <input value="" v-model="form.quant" type="text" class="form-control" id="exampleFormControlInput1" placeholder="ex.: 10">
              </div>
              <div v-if="!descart" class="col mb-3">
                <label for="exampleFormControlInput1" class="form-label">Valor de Compra:</label>
                <input value="" v-model="form.buy" type="text" class="form-control" id="exampleFormControlInput1" placeholder="ex.: 10,00">
              </div>
            </div>
              <div v-if="descart" class="mb-3">
                <label for="exampleFormControlInput1" class="form-label">Descrição:</label>
                <input value="" v-model="form.description" type="text" class="form-control" id="exampleFormControlInput1" placeholder="Motivo do descarte">
              </div>
              <div v-if="!descart" class="mb-3">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Lote:</label>
                  <div class="col-10">
                      <input autocomplete="off" type="text" v-model="form.lote" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="Pesquisar fornecedor">
                  </div>
                </div>
                <div class="row">
                    <div class="col mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Fabricação:</label>
                      <div class="col-10">
                          <input autocomplete="off" type="text" v-model="form.fabricacao" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="Pesquisar fornecedor">
                      </div>
                    </div>
                    <div class="col mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Validade:</label>
                      <div class="col-10">
                          <input autocomplete="off" type="text" v-model="form.validade" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="Pesquisar fornecedor">
                      </div>
                    </div>
                </div>

                <div class="row">
                  <label for="exampleFormControlInput1" class="form-label">Fornecedor:</label>
                  <div class="col-10">
                      <input autocomplete="off" type="text" v-model="buscasupplier" @input="filtrarSugestoesFornecedor" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="Pesquisar fornecedor">
                  </div>
                  <div class="col-2">
                      <button @click="limparPesquisa()" type="button" class="btn btn-outline-danger">X</button>
                  </div>
                </div>
                <div class="mt-2 p-2 border rounded" v-if="sugestoes.length">
                    <table class="table mb-0 table-borderless">
                        <tbody>
                            <tr class="lc3tableline" v-for="(item, index) in sugestoes"
                                :key="item.id"
                                @click="selecionarSupplier(item)" >
                                <td>{{ item.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" class="btn btn-primary">Enviar</button>
          </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
  import { onMounted, reactive, ref, computed } from 'vue';
  import AppLayout from "@/components/AppLayout.vue";
  import { Modal } from "bootstrap";
  import { produtos } from "@/models/produtos";
  import { fornecedores } from "@/models/fornecedores";
  import { lojas } from "@/models/lojas";

  export default {
    name: 'PainelView',
    components: {
      AppLayout
    },
    setup(props) {
      const Produtos = produtos()
      const lista_produtos = ref([]);
      const lista_fornecedores = ref([]);
      const Forncedores = fornecedores();
      const buscasupplier = ref([]);
      const sugestoes = ref([]);

      // Estoque é por loja — enquanto o tenant só tiver uma, o seletor fica
      // escondido (ver template) e `selectedStoreId` some do payload.
      const Lojas = lojas();
      const lista_lojas = ref([]);
      const selectedStoreId = ref(null);

      var edit = ref(false);
      var msn_feedback = ref('');
      var feedback_error = ref(false);
      var autorizated_delet = ref(false);
      var descart = ref(false);
      var autorizated_descart = ref(false);

      var sendtrue = false;

      // Variáveis de paginação
      const currentPage = ref(1);
      const totalPages = ref(1);
      const totalProdutos = ref(0);
      const perPage = ref(11);

      let modal = '';

      // Sessão do leitor de codigos
      const buffer = ref('');
      let timeout = null;

      function handleKeypress(e) {
          if (timeout) clearTimeout(timeout);
          buffer.value += e.key;
          timeout = setTimeout(() => {
              if (buffer.value.length >= 6) {
                  produto.code = buffer.value.slice(0, -5);
              }
              buffer.value = '';
          }, 50);
      }

      var produto = reactive({
        'id' : '',
        'name' : '',
        'code' : '',
        'price' : '',
        'measure' : '',
        'visible' : '1',
        'buy' : ''
      })

      var form = reactive({
        'quant' : '',
        'buy' : '',
        'description' : '',
        'supplier' : '',
        'lote' : '',
        'validade' : '',
        'fabricacao' : '',
        'product' : produto
      })

      // Computed: gera array de páginas para os botões
      const pages = computed(() => {
        const p = [];
        for (let i = 1; i <= totalPages.value; i++) {
          p.push(i);
        }
        return p;
      });

      function openModal(elemento) {
        const modalNovoProduto = document.getElementById(elemento);
        modal = new Modal(modalNovoProduto);
        modal.show();
      }

      function closeModal() {
        modal.hide();
      }

      function limparDados() {
        produto.name = ''
        produto.id = ''
        produto.price = ''
        produto.code = ''
        produto.stock = ''
        produto.measure = ''
        produto.visible = '1'
        produto.buy = ''
      }

      const saveProduct = async () => {
        feedback_error.value = false;
        const result = await Produtos.createItem({ ...produto, store_id: selectedStoreId.value });
        if (result === true) {
          closeModal();
          msn_feedback.value = 'Produto cadastrado com sucesso!';
          openModal('modal_feedback');
          limparDados();
          refresh(currentPage.value);
        } else {
          closeModal();
          feedback_error.value = true;
          msn_feedback.value = result;
          openModal('modal_feedback');
        }
      }

      const descartProduct = async () => {
        if (await Produtos.descart(form.product.id, { quant: form.quant, description: form.description, store_id: selectedStoreId.value })) {
          closeModal();
          msn_feedback.value = 'Produto descartado com sucesso!';
          openModal('modal_feedback');
          limparDados();
          refresh(currentPage.value);
        } else {
          console.log('Erro ao cadastrar novo produto');
        }
      }

      const replaceProduct = async () => {
        if (await Produtos.replace(form.product.id, { quant: form.quant, buy: form.buy, supplier_id: form.supplier || null, store_id: selectedStoreId.value })) {
          closeModal();
          msn_feedback.value = 'Produto reposto com sucesso!';
          openModal('modal_feedback');
          limparDados();
          refresh(currentPage.value);
        } else {
          console.log('Erro ao repor produto');
        }
      }

      const show_deleteProduct = async (item) => {
        openModal('modal_deletar');
        select_product(item);
      }

      const deleteProduct = async () => {
        if (await Produtos.deleteItem(produto.id)) {
          closeModal();
          msn_feedback.value = 'Produto deletado com sucesso!';
          openModal('modal_feedback');
          refresh(currentPage.value);
        } else {
          console.log('Erro ao cadastrar novo produto');
        }
      }

      const updateProduct = async () => {
        if (await Produtos.updateItem(produto)) {
          msn_feedback.value = "Produto atualizado com sucesso!"
          closeModal();
          openModal('modal_feedback');
          refresh(currentPage.value);
        } else {
          console.log('Erro ao cadastrar novo produto');
        }
      }

      function show_repor(item) {
        descart.value = false;
        select_product(item);
        openModal('modal_movimentacao')
      }

      function show_descart(item) {
        descart.value = true;
        select_product(item);
        openModal('modal_movimentacao')
      }

      const show_novoProduto = () => {
        limparDados();
        edit.value = false;
        openModal('modal_produto');
      }

      const actionMoviment = () => {
        if (descart.value) {
          descartProduct();
        } else {
          replaceProduct();
        }
      }

      function select_product(item) {
        produto.name = item.name
        produto.id = item.id
        produto.price = item.price
        produto.code = item.code
        produto.stock = item.stock
        produto.measure = item.measure
        produto.visible = item.visible
        produto.buy = item.buy
      }

      const show_editProduct = (item) => {
        edit.value = true;
        select_product(item);
        openModal('modal_produto');
      }

      const actionProduct = () => {
        if (edit.value) {
          updateProduct();
        } else {
          saveProduct();
        }
      }

      function preActionProduct() {
        if (sendtrue) {
          actionProduct();
          sendtrue = false;
        }
      }

      const changePage = (page) => {
        if (page < 1 || page > totalPages.value) return;
        currentPage.value = page;
        refresh(page);
      }

      const refresh = async (page = 1) => {
        var produtos_retorno = await Produtos.list(page, selectedStoreId.value);
        if (produtos_retorno) {
          lista_produtos.value = produtos_retorno.data;
          totalPages.value = produtos_retorno.pages || 1;
          currentPage.value = produtos_retorno.page || 1;
          totalProdutos.value = produtos_retorno.total || 0;
          perPage.value = produtos_retorno.perPage || 11;
        }
      }

      function selecionarSupplier(item) {
        form.supplier = item.id
        buscasupplier.value = item.name
        sugestoes.value = [];
      }

      function limparPesquisa() {
        buscasupplier.value = ''
        sugestoes.value = [];
      }

      function filtrarSugestoesFornecedor() {
            if (buscasupplier.value.length === 0) {
                sugestoes.value = [];
                return;
            }

            sugestoes.value = lista_fornecedores.value.filter(item =>
                item.name.toLowerCase().includes(buscasupplier.value.toLowerCase())
            );
      }

      onMounted(async function () {
        lista_lojas.value = await Lojas.list();
        selectedStoreId.value = (lista_lojas.value.find(l => l.is_default) ?? lista_lojas.value[0])?.id ?? null;

        refresh();

        //Função: leitor de codigos
        window.addEventListener('keypress', handleKeypress);
      });

      return {
        autorizated_delet,
        msn_feedback,
        feedback_error,
        produto,
        actionProduct,
        show_deleteProduct,
        deleteProduct,
        lista_produtos,
        show_editProduct,
        edit,
        show_novoProduto,
        show_repor,
        show_descart,
        form,
        sugestoes,
        buscasupplier,
        limparPesquisa,
        filtrarSugestoesFornecedor,
        selecionarSupplier,
        descart,
        actionMoviment,
        sendtrue,
        preActionProduct,
        // Paginação
        currentPage,
        totalPages,
        totalProdutos,
        perPage,
        pages,
        changePage,
        refresh,
        // Lojas
        lista_lojas,
        selectedStoreId
      }
    },
  }
  </script>
